import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {CommonModule, DatePipe} from '@angular/common';
import { NgModule,ErrorHandler, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NgbModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { NavigationComponent } from './shared/header-navigation/navigation.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { Approutes } from './app-routing.module';
import { AppComponent } from './app.component';
import { SpinnerComponent } from './shared/spinner.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { OAuthModule } from 'angular-oauth2-oidc';
import { CoreModule } from './core/core.module';
import { CommonServicesModule } from './commonservices/commonservices.module';
import { SigninRedirectCallbackComponent } from './starter/signin-redirect-callback.component';
import { SignoutRedirectCallbackComponent } from './starter/signout-redirect-callback.component';
import { Applications } from './applications/applications.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { WindowModule  } from '@progress/kendo-angular-dialog';
import { EnvServiceProvider } from './core/env.service.provider';
import { SharedModule } from './shared/shared.module';
import { SpinnerService } from './core/loader/spinner.service';
import { SpinnerInnerComponent } from './core/loader/spinnerinner.component';
import { AuthInterceptorService } from './core/auth-interceptor.service';
import { StorageServiceModule } from 'ngx-webstorage-service';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ToastrModule } from 'ngx-toastr'; 
import { LOCALE_ID } from '@angular/core';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { CookieModule } from 'ngx-cookie';

import { ShareService } from './commonservices/shared.service';
import { GlobalService } from './commonservices/global.service';
import { JwPaginationModule } from 'jw-angular-pagination';
import { NgChartsModule } from 'ng2-charts';
import {NgIdleModule} from '@ng-idle/core'

import { WebResService } from './webresolution/service/webresservices';
import { MultiRaterService } from './multirater/service/multirater-service';
import { CountriesService } from './multirater/service/countries.service';

import { AttachDocumentModalComponent } from './webresolution/modal/attachDocument.component';
import { UploadModule } from '@progress/kendo-angular-upload';
import { ClickOutsideDirective } from './directive/click-outside.directive';



import {AttachComponent} from './commoncomponent/AttachComponent/attach.component';
import { ModalModule } from './commoncomponent/Modal/modal.module'
import { IcalcModule } from './commoncomponent/Icalc/icalc.module'
import { SelectFieldsModule } from './commoncomponent/SelectFields/select-fields.module'

import { CustomCheckboxModule } from 'angular-custom-checkbox';

import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NZ_I18N, en_US } from 'ng-zorro-antd/i18n';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzTableModule } from 'ng-zorro-antd/table';


import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { LabelModule } from "@progress/kendo-angular-label";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { RuleModule } from './rules/rule.module'


import { NzConfig, NZ_CONFIG } from 'ng-zorro-antd/core/config';
import { AuthRouteGuard } from './core/auth-route-guard';
import { UpdateService } from './core/update-service.component';

const ngZorroConfig: NzConfig = {
  message: { nzTop: 0, nzMaxStack: 1 },
  notification: { nzTop: 20 },
};


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true,
  minScrollbarLength: 20
};

@NgModule({
    declarations: [
        AppComponent,
        SpinnerComponent,
        SpinnerInnerComponent,
        FullComponent,
        BlankComponent,
        NavigationComponent,
        BreadcrumbComponent,
        SidebarComponent,
        SigninRedirectCallbackComponent,
        SignoutRedirectCallbackComponent,
        Applications,
        AttachDocumentModalComponent,
        AttachComponent,
        ClickOutsideDirective
    ],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        OAuthModule.forRoot(),
        ToastrModule.forRoot(),
        NgbModule,
        RouterModule.forRoot(Approutes),
        FormsModule,
        CookieModule.forRoot(),
        PerfectScrollbarModule,
        CoreModule,
        CommonServicesModule,
        SharedModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        WindowModule,
        StorageServiceModule,
        LayoutModule,
        DialogModule,
        LabelModule,
        InputsModule,
        // NgZorroAntdModule,
        DropDownsModule,
        JwPaginationModule,
        NgChartsModule,
        NgIdleModule.forRoot(),
        UploadModule,
        DateInputsModule,
        ModalModule,
        IcalcModule,
        CustomCheckboxModule,
        NzModalModule,
        NzNotificationModule,
        NzButtonModule,
        NzIconModule,
        NzLayoutModule,
        NzGridModule,
        NzDropDownModule,
        NzCheckboxModule,
        NzDatePickerModule,
        NzInputModule,
        NzSelectModule,
        NzFormModule,
        NzInputNumberModule,
        NzTableModule,
        ButtonsModule,
        NgbDropdownModule,
        RuleModule
    ],
    providers: [
        AuthRouteGuard,
        OAuthModule,
        EnvServiceProvider,
        GlobalService,
        SpinnerService,
        ShareService,
        WebResService,
        MultiRaterService,
        CountriesService,
        { provide: NZ_I18N, useValue: en_US },
        { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
        // { provide: ErrorHandler, useClass: GlobalErrorHandler},
        { provide: LOCALE_ID, useValue: 'en-US' },
        { provide: NZ_CONFIG, useValue: ngZorroConfig },
        DatePipe,
        UpdateService
    ],
    exports: [
        JwPaginationModule,
        // ChartsModule,
        SharedModule,
        AttachDocumentModalComponent,
        NzModalModule,
        NzNotificationModule,
        NzButtonModule,
        NzIconModule,
        NzLayoutModule,
        NzGridModule,
        NzDropDownModule,
        NzCheckboxModule,
        NzDatePickerModule,
        NzInputModule,
        NzSelectModule,
        NzFormModule,
        NzInputNumberModule,
        NzTableModule
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
